import edjsParser from 'editorjs-html';
import { OutputData } from '@editorjs/editorjs';

/**
 * Renders an EditorJS document to HTML and opens it in a new browser window
 * so the user can print it or save it as PDF.
 */
export function openDocumentPrintWindow(title: string, content: unknown): void {
  const parser = edjsParser();
  const bodyHtml = parser.parse(content as OutputData);

  const html = `<!DOCTYPE html>
<html lang="sk">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${escapeHtml(title)}</title>
  <style>
    body { font-family: sans-serif; max-width: 800px; margin: 40px auto; padding: 0 24px; color: #111; }
    h1, h2, h3, h4, h5, h6 { margin-top: 1.2em; }
    p { line-height: 1.6; }
    table { border-collapse: collapse; width: 100%; }
    td, th { border: 1px solid #ccc; padding: 6px 10px; }
    img { max-width: 100%; }
    @media print { body { margin: 0; } }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  ${bodyHtml}
</body>
</html>`;

  const win = window.open('', '_blank');
  if (win) {
    win.document.write(html);
    win.document.close();
  }
}

function escapeHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
